module.exports = __webpack_public_path__ + "static/media/1025662.ef49f9b4.jpg";